import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, Image } from "../AbstractElements";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { requestForToken } from "../firebase";
import axiosInstance from "../interceptor/intercetptor-inctence";
import Loader from "../Layout/Loader";
import { useTranslation } from "react-i18next";
import logoLight from '../../src/assets/images/login/logo_white.png';
import logoDark from '../../src/assets/images/login/logo_dark.png';
import assets5 from '../../src/assets/images/login/Asset-5.png';
import coatOfArms from '../../src/assets/images/login/Coat_of_arms_of_Zimbabwe.png';
import { useLoader } from "../_helper/LoaderContext";
import { secureApiRequest } from "../Services/secureApiRequest";
import { decryptResponseData } from "../Services/decryptApiResponse";

const ForgotPassword = () => {
	const { t } = useTranslation();
	const [email, setEmail] = useState("");
	const [emailError, setEmailError] = useState("");
	const history = useNavigate();
	const { setLoading } = useLoader();

	const [containerHeight, setContainerHeight] = useState(window.innerHeight);
	useEffect(() => {
		const handleResize = () => {
			setContainerHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleEmailChange = (e) => {
		setEmail(e.target.value);
		setEmailError(""); // Clear email error when user types
	};

	const validateFields = () => {
		let isValid = true;
		// Email validation
		if (!email) {
			setEmailError("emailRequired");
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			console.log("Invalid email format");
			setEmailError("enterValidEmail");
			isValid = false;
		}
		return isValid;
	};

	const handleSubmit = async (e) => {
		e.preventDefault(); // Prevent form submission
		if (validateFields()) {
			const body = {
				// role: 'clinic_admin',
				email: email.toLowerCase()
			}
			try {
				setLoading(true);
				const response = await axiosInstance.post(`healthcare_providers/auth/requestForgotPassword`, body);
				// const response = await axiosInstance("post", `healthcare_providers/auth/requestForgotPassword`, body);
				// const dec_data = decryptResponseData(response);
				const dec_data = response.data;
				if (dec_data.status === "success") {
					toast.success(dec_data.message, {
						autoClose: 1000, // Display toast for 2 seconds
						onClose: () => {
							const userId = dec_data.data;
							// console.log('user id: ' + userId);
							// history(`${process.env.PUBLIC_URL}/reset-password/${userId}`, { replace: true });
							setEmail(""); // Clear the email field
						}
					});
					setLoading(false);
				}
			} catch (error) {
				setLoading(false);
				console.error('Error fetching data:', error);
				// toast.warning('An error occurred'); // You may want to toast errors as well
			}

		}
	};

	const backToLogin = () => {
		history(`${process.env.PUBLIC_URL}/login`);
	};

	return (
		<Fragment>
			<div className="login-page">
				<Container fluid={false} style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
					<div className="card">
						<Row>
							<Col
								xs="6"
								className="b-center bg-size d-none d-md-flex flex-column"
								style={{
									backgroundImage: `url(${require('../assets/images/login/login_left_img.png')})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									// borderTopLeftRadius: '15px',
									// borderBottomLeftRadius: '15px',
									// padding: '20px',
									color: '#1B245B', // Ensures text is white on the dark background
								}}
							>
								<div style={{ marginLeft: "10%" }}>
									<Image
										attrImage={{
											className: 'login-logo-style',
											src: `${logoDark}`,
											alt: 'CLINICDOTS Logo',
										}}
									/>
									<h3 style={{ fontWeight: 'bold', marginBottom: '0px' }}>CLINICDOTS</h3>
									<h3 style={{ fontWeight: 'bold', marginBottom: '20px' }}>HEALTHCARE</h3>
									<span>{t("Innovating Healthcare for India.")}</span>
								</div>
							</Col>

							<Col xs="12" md="6"
								style={{
									backgroundImage: `url(${require('../assets/images/login/login_right_img.png')})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									// borderTopLeftRadius: '15px',
									// borderBottomLeftRadius: '15px',
									minHeight: `${containerHeight * 0.94}px`,
									display: 'flex',
									flexDirection: 'column'
								}}>
								<div className='login-card' style={{ flex: '1' }}>
									<div className="login-form-responsive">
										<Form className="theme-form login-form" onSubmit={handleSubmit}>
											{/* This image will only be visible on mobile screens */}
											<Image
												attrImage={{
													className: 'login-dark-logo-style d-block d-md-none',
													src: `${logoDark}`,
													alt: 'CLINICDOTS Logo',
												}}
											/>
											<H4><strong className="mb-3">{t("forgotPassword")}</strong></H4>
											<P>{t("enterEmailForOtp")}</P>

											<FormGroup className="position-relative">
												<Label className="col-form-label">{t("Email")}</Label>
												<div className="position-relative">
													<i className="fa fa-envelope-o position-absolute" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize: "large" }}></i>
													<Input
														className="form-control pl-5"
														type="email"
														placeholder={t("enterEmail")}
														onChange={handleEmailChange}
														value={email}
														style={{ paddingLeft: '40px' }}
														required=""
													/>
												</div>
												{emailError && <div className="text-danger">{t(emailError)}</div>}
											</FormGroup>

											<div className="position-relative form-group mb-0">
												<Btn attrBtn={{ color: "primary", className: "d-block w-100 login-button" }}>{t("forgotPassword")}</Btn>
											</div>
											<p className="my-3 text-center">{t("backTo")} <strong style={{ color: "#1b255b", cursor: "pointer" }} onClick={backToLogin}>{t("Login")}</strong></p>
										</Form>
									</div>
								</div>
								{/* <div className="mx-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								<small style={{ marginRight: 'auto' }}>
									{t("All rights reserved Copyright ©")} {new Date().getFullYear()} {t("CLINICDOTS HEALTHCARE.")}
								</small>
								<div style={{ display: 'flex', gap: '10px' }}>
									<Image
										attrImage={{
											className: 'mb-4 login-footer-logo',
											src: `${assets5}`,
											alt: 'Assets 5 Logo',
										}}
									/>
									<Image
										attrImage={{
											className: 'mb-4 login-footer-logo',
											src: `${coatOfArms}`,
											alt: 'Coat Of Arms Logo',
										}}
									/>
								</div>
							</div> */}
							</Col>
						</Row>
					</div>
				</Container>
			</div>
			<ToastContainer />
		</Fragment>
	);
};

export default ForgotPassword;
